import React from 'react';

/**
 * A component that displays a message with a title and text.
 *
 * @component
 * @param {string} title - The title of the message
 * @param {string} message - The message content of the message
 * @param {string} type - Optional type of notice to render ("warning", "error", "success", or "informational").
 * @returns {React.ReactElement|null} The message component or null if displayMessage is false
 */
const CourseNoticeComponent = ({title, message, type}) => {
    const combinedClasses = type ? `messages ${type}` : 'messages';

    return (
        <div className="course-template-message">
            <div className={combinedClasses}>
                <h4>{title}</h4>
                <div dangerouslySetInnerHTML={{__html: message}}></div>
            </div>
        </div>
    );
};

export default CourseNoticeComponent;
